import { signInConstant } from "../_constants/signIn.constant";
import { signInService } from "../_services/signIn.service";
import { alert } from "../_utilities/alert";

export const signInAction = {
    createSignIn,
    // getSignIn
}

function createSignIn(data) {
    return (dispatch) => {
        dispatch(
            dispatchFunction({
                type: signInConstant.CREATE_SIGNIN_REQUEST,
                data: null,
            })
        );
        signInService
            // .createSignIn(data)
            .createSignIn({ ...data })
            .then(
                (response) => {
                    if (response.Status === 200) {
                        dispatch(
                            dispatchFunction({
                                type: signInConstant.CREATE_SIGNIN_SUCCESS,
                                data: response.Result,
                            })
                        );
                        alert.success(response.Message);
                    } else {
                        dispatch(
                            dispatchFunction({
                                type: signInConstant.CREATE_SIGNIN_FAILURE,
                                data: null,
                            })
                        );
                        alert.error(response.Message);
                    }
                },
                (error) => {
                    dispatch(
                        dispatchFunction({
                            type: signInConstant.CREATE_SIGNIN_FAILURE,
                            data: error,
                        })
                    );
                    alert.error("Oops! Something went wrong!!");
                }
            )
            .catch((error) => {
                alert.error("Oops! Something went wrong!!");
            });
    };
}

// function getSignIn() {
//     return (dispatch) => {
//         dispatch(
//             dispatchFunction({
//                 type: signInConstant.GET_SIGNIN_REQUEST,
//                 data: null,
//             })
//         );
//         signInService
//             .getSignIn()
//             .then(
//                 (response) => {
//                     if (response.Status === 200) {
//                         dispatch(
//                             dispatchFunction({
//                                 type: signInConstant.GET_SIGNIN_SUCCESS,
//                                 data: response.Result,
//                             })
//                         );
//                     } else {
//                         dispatch(
//                             dispatchFunction({
//                                 type: signInConstant.GET_SIGNIN_FAILURE,
//                                 data: null,
//                             })
//                         );
//                     }
//                 },
//                 (error) => {
//                     dispatch(
//                         dispatchFunction({
//                             type: signInConstant.GET_SIGNIN_FAILURE,
//                             data: error,
//                         })
//                     );
//                     alert.error("Oops! Something went wrong!!");
//                 }
//             )
//             .catch((error) => {
//                 alert.error("Oops! Something went wrong!!");
//             });
//     };
// }

function dispatchFunction(data) {
    return {
        type: data.type,
        data: data.data,
    };
}